import { useSnackbar } from 'notistack';

let useSnackbarRef
export const SnackbarUtilsConfigurator = () => {
    useSnackbarRef = useSnackbar()
    return null
}


export const showToast = (message, variant = 'success', autoHideDuration = 2000) => {
    useSnackbarRef.enqueueSnackbar(message, {
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        variant: variant,
        autoHideDuration: autoHideDuration,
    });
};

export const showErrorToast = (error, customMessage = null, autoHideDuration = 2000) => {
    // check if error is string
    if (typeof error === "string") {
        showToast(error, 'error', autoHideDuration);
        return;
    }

    // check if error is axios error
    let error_msg_key = error?.response?.data && typeof error?.response?.data === "object" ? Object.keys(error?.response?.data)?.[0] : null;
    let err_msg = error?.response?.data?.message || error?.response?.data?.[error_msg_key];
    const message = error?.customMessage || err_msg || customMessage || "Something went wrong!";
    showToast(message, 'error', autoHideDuration);
};

export const showSuccessToast = (message, autoHideDuration = 2000) => {
    showToast(message, 'success', autoHideDuration);
};